import React from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { Title } from 'advenio-components'
import Demographics from './Demographics'
import Disenrollments from './Disenrollments'
import Net from './Net'
import Motives from './Motives'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  padding: 32px;
`
const ReportContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
`
const TitleContainer = styled.div`
`

const KidsReports = ({ fromCenter }) => (
  <Container>
    {!fromCenter && (
      <TitleContainer>
        <Title>Niños</Title>
      </TitleContainer>
    )}
    <ReportContainer>
      <Demographics fromCenter={fromCenter} />
      <Disenrollments fromCenter={fromCenter} />
      <Net fromCenter={fromCenter} />
      <Motives fromCenter={fromCenter} />
    </ReportContainer>
  </Container>
)

KidsReports.propTypes = {
  /** Flag marking whether the reports are being viewed within a Center */
  fromCenter: PropTypes.bool,
}

KidsReports.defaultProps = {
  fromCenter: false,
}

export default withRouter(KidsReports)



// WEBPACK FOOTER //
// ./src/Containers/Reports/KidsReports.jsx